export default {
  headerContent: {
    title: 'Generali Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Generali Sigorta DASK',
    description: {
      title:
        'Generali Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Generali Sigorta zorunlu deprem sigortası, deprem sonucunda oluşan kayıpları güvence altına almaktadır.',
        'Deprem sigortası, konutta oluşacak deprem ve deprem sonucu yangın, infilak gibi hasarlara karşı koruma sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Generali Sigorta Zorunlu Deprem Sigortası ZDS Teminatları Neler?',
      content: [
        {
          paragraph: 'Zorunlu deprem sigortası teminatları;',
          subList: [
            'Deprem Sonrası Maddi Zarar',
            'Deprem Sonrası Yangın',
            'Deprem Sonrası İnfilak',
            'Deprem Sonrası Tsunami',
            'Deprem Sonrası Yer Kayması teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Generali Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Generali Sigorta Zorunlu Deprem Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartları gereğince teminat dışı kalan haller;',
          subList: [
            'Alternatif ikametgah ve işyeri masrafları',
            'Deprem ve deprem sonucu oluşan yangın, infilak, tsunami veya yer kaymasının dışında kalan hasarlar',
            'Depremden bağımsız olarak, binanın kendi kusurlu yapısı nedeniyle zamanla oluşmuş zararlar',
            'Enkaz kaldırma masrafları',
            'Her türlü taşınır mal, eşya ve benzerleri',
            'İş durması',
            'Kar kaybı',
            'Kira mahrumiyeti',
            'Mali sorumluluklar ve benzeri başkaca ileri sürülebilecek diğer bütün dolaylı zararlar',
            'Manevi tazminat talepleri',
            'Tüm bedeni zararlar ve vefat'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Hangi Binalar Zorunlu Deprem Sigortası Kapsamındadır?',
      content: [
        {
          paragraph:
            'Genel şartlarda belirtilmiş binalar hariç tüm binalar kapsam dahilindedir.',
          subList: null
        },
        {
          paragraph: 'Bu binalar;',
          subList: [
            'Tapuya kayıtlı ve özel mülkiyete tabi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar,',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler,',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler,',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler.',
            'Zorunlu Deprem Sigortası ayrıca yukarıdaki koşullara uyan;',
            'Kat irtifakı tesis edilmiş binalar,',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar,',
            'Tapu tahsisi henüz yapılmamış kooperatif evleri,'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Zorunlu Deprem Sigortası Kapsamında Yer Alan Konut Bölümleri Nelerdir?',
      content: [
        {
          paragraph:
            'Deprem sigortası genel şartlarına göre kapsam altında olan bölümler;',
          subList: [
            'Temeller',
            'Ana duvarlar',
            'Bağımsız bölümleri ayıran ortak duvarlar',
            'Bahçe duvarları',
            'İstinat duvarları',
            'Tavan ve tabanlar',
            'Merdivenler',
            'Asansörler',
            'Sahanlıklar',
            'Koridorlar',
            'Çatılar',
            'Bacalar',
            'Yapının yukarıdakilerle benzer nitelikteki tamamlayıcı bölümlerinden oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Hangi Binalar Genel Şartlar Gereğince Zorunlu Deprem Sigortası Kapsamında Değildir?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası kapsamı dışında kalan bina türleri aşağıdaki gibidir:',
          subList: [
            '9/11/1983 tarihli ve 2946 sayılı Kamu Konutları Kanununa tâbi olan veya kamu hizmet binası olarak kullanılan binalar ve bağımsız bölümler,',
            'Köy nüfusuna kayıtlı ve köyde sürekli oturanlarca köy yerleşik alanları ve civarında ve mezralarda yapılan binalar,',
            'Tamamı ticari veya sınai amaçla kullanılan binalar,',
            'Projesi bulunmayan ve mühendislik hizmeti görmemiş binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde tadil edildiği veya zayıflatıldığı tespit edilen binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde ilgili mevzuata ve projeye aykırı olarak inşa edilen binalar,',
            'Yetkili kamu kurumları tarafından yıkılmasına karar verilen binalar ile mesken olarak kullanıma uygun olmayan, bakımsız, harap veya metruk binalar,',
            'ZDS kapsamı dışındaki binalara, İhtiyari Deprem Sigortası yaptırabilirsin.',
            'Köy yerleşimleri -genel olarak gelir düzeyinin düşük olması, binalarda belediye denetiminin bulunmaması ve sigortanın sunumunun zor olması gibi nedenlerle- sigorta kapsamı dışında yer alır. Ancak, köylerde bulunan yapılar için istendiği takdirde İhtiyari Deprem Sigortası yaptırılması mümkündür. Benzer şekilde ticari ve sanayi amaçlar için kullanılan binalar için de İhtiyari Deprem Sigortası yaptırılabilir.'
          ]
        }
      ]
    },
    {
      title:
        'Generali Sigorta Zorunlu Deprem Sigortasında Eşyalar Teminat Kapsamında Mı?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası sadece konutu kapsamaktadır. Eşya veya özel dekorasyonlar teminat dahilinde değildir. ',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Adres Kodu Nedir?',
      content: [
        {
          paragraph:
            'Deprem sigortası adres kodu diğer adıyla UAVT kodu konutun uluslararası veri tabanında kayıtlı olması sonucunda verilen numaralı kodudur. Bu kod deprem sigortası düzenlenmek için gereklidir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Sigorta Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Bina bedeli poliçe üzerinde yazan ve deprem sonucunda binanın yıkılması veya hasar alması sonucunda konutun tekrar yapılabilmesi için gerekli finansal ücrettir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK Yenileme Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask yenilemesi geçmiş dönem poliçesi üzerinde yazan Dask poliçe numarasıyla yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası, sisteme sigortalı ve konut bilgileri girilerek hesaplaması yapılmaktadır. Bu hesaplama sonucu prim müşteriye ileterek müşteri onayı beklenmektedir. Müşteri onay vermesi sonucunda ödeme bilgisi alınarak poliçe üretimi sağlanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK (Zorunlu Deprem Sigortası) Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Dask sigortası olası bir deprem sonucunda konutun kullanamaz hale gelmesi durumunda hak sahibine bina bedelini ödeyerek büyük maddi kayıpların önüne geçmektedir.',
          subList: null
        },
        {
          paragraph:
            'Sadece binanın yıkılması değil deprem sonucu oluşan kısmı hasarları da kapsamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK İçin Gerekli Belgeler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'DASK sigortası sigortalı ve konutun bilgileri doğrultusunda hazırlanmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu bilgiler;',
          subList: [
            'Binanın hasar durumu,',
            'Binanın inşa yılı,',
            'Binanın kaç katlı olduğu, ',
            'Binanın yapı tarzı,',
            'Konutun brüt yüz ölçümü (m²), ',
            'Konutun kullanım şekli,',
            'Sigortalanacak yerin açık adresi, ',
            'Sigortalının vergi ve T.C. kimlik numarasından oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK Su Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Dask sigortası sadece deprem sonucu çıkan su hasarlarını kapsamaktadır. Deprem sonucu oluşmayan su hasarlarını konut sigortası yaptırarak güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK İle Konut Sigortası Arasındaki Fark Nedir?',
      content: [
        {
          paragraph:
            'Deprem sigortası, deprem sonucu konutta oluşacak yangın, infilak ve yer kayması hasarlarını karşılamaktadır. Kanunen konut sahibinin yaptırması gerekmektedir.',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası ise konutta oluşabilecek yangın, hırsızlık, sel ve su baskını gibi hasarlara karşı güvence altına almaktadır. Konut sigortası isteğe bağlı olarak yapılan bir sigorta ürünüdür. Konut sigortasını ister kiracı isterse ev sahibi yaptırabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Zorunlu Deprem Sigortası Yaptırmadan Konut Poliçesi Yaptırmak Mümkün Mü?',
      content: [
        {
          paragraph:
            'Deprem sigortası olmadan konut sigortası yapılmaktadır. Depremsiz konut sigortası yaptırarak evinizde oluşabilecek yangın, hırsızlık, sel ve su baskını gibi hasarlara karşı kendinizi güvence altına alabilirsiniz. Sadece konutunuzu değil içerisinde bulunan eşyalara da koruma altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta Zorunlu Deprem Sigortasında Tazminat Ödenmesi Ne Şekilde Olur?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi tazminat miktarının belirlenmesinin ardından Doğal Afet Sigortaları Kurumu tarafından poliçede yazan bedeli aşmamak kaydıyla en geç bir ay içerisinde hak sahibine yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Ev Satışından Sonra Generali Sigorta DASK İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartlar gereğince iptal edilememektedir. Fakat ev satışından sonrada Dask iptal edilememekte olup yeni alan kişinin üzerine aktarılabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta DASK (Zorunlu Deprem Sigortası) Hasar İhbarı Nereye Yapılır?',
      content: [
        {
          paragraph:
            'Hasar ihbarını sigorta şirketinize veya poliçenizi satın almış olduğunuz aracı kuruma veya doğal afetler kurumuna bildirebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK Ne Kadar Ödeme Yapar?',
      content: [
        {
          paragraph:
            'Dask sigortası hasar ihbarının yapılmasının ardından eksper tayin edilerek hasar miktarı hesaplaması yapılmaktadır. Yapılan hesaplama sonucunda ödeme yapılmaktadır. Tazminat ödemeleri poliçede yazan bina bedeli aşmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Deprem Sigortası Nerede Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortanızı sigorta şirketinden veya aracılık hizmeti veren kurumlardan yapılabilir.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu deprem sigortanızı alokasko aracılığı ile yaptırabilirsiniz. Bunun için yapmanız gereken alokasko.com üzerinde yer alan başvuru formunu doldurmak.  ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK (Poliçe) Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask hesaplaması Doğal Afet Sigortaları Kurumu tarafından yapılmaktadır. Kurum tarafından her yıl yapı maliyetleri hesaplanarak metrekare yapım maliyeti çıkarılır. Çıkarılan maliyet binanın metrekaresi ile çarpılarak bina bedeli hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK Zorunlu Deprem Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası dairenin metrekaresi ve binanın bulunduğu adrese göre değişmektedir. Bu sebeple net bir fiyat söylemek mümkün değildir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Generali Sigorta DASK Zorunlu Deprem Sigortası Online Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Dask sigortasını online olarak almanız mümkündür. Bunun için tek yapmanız gereken alokasko.com üzerinden başvuru formunda yer alan bilgileri doldurmanızdır. Online DASK teklifi için sayfamızda bulunan formu doldurabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
